import { createSlice  } from '@reduxjs/toolkit'

const initialState = {
    clientList: {
        requesting: false,
        items: [],
        pagination: {
            current_page: 1,
            per_page: 10,
            total: 0,
        },
        error: null,
        success: false,
        filters: {},
    },
    clientDetails: {
        requesting: false,
        error: null,
        success: false,
        data: null
    },
    //
    clientTeamList: {
        requesting: false,
        items: [],
        pagination: {
            current_page: 1,
            per_page: 10,
            total: 0,
        },
        error: null,
        success: false,
        filters: {},
    },
    clientTeamDetails: {
        requesting: false,
        error: null,
        success: false,
        data: null
    },
    //
    clientUserList: {
        requesting: false,
        items: [],
        pagination: {
            current_page: 1,
            per_page: 10,
            total: 0,
        },
        error: null,
        success: false,
        filters: {},
    },
    clientUserDetails: {
        requesting: false,
        error: null,
        success: false,
        data: null
    },
    //
    clientSettingList: {
        requesting: false,
        items: [],
        pagination: {
            current_page: 1,
            per_page: 10,
            total: 0,
        },
        error: null,
        success: false,
        filters: {},
    },
    clientSettingDetails: {
        requesting: false,
        error: null,
        success: false,
        data: null
    },
  };

export const clientSlice = createSlice({
  name: 'client',
  initialState,
  reducers: {
    getClientList: (state, action) => {
        state.clientList.requesting = true;
        state.clientList.error = null;
        state.clientList.items = [];
        state.clientList.success = false;
        state.clientList.filters = action.payload;
    },
    getClientListSuccess: (state, action) => {
		const { data, current_page, per_page, total} = action.payload;
        state.clientList.requesting = false;        
        state.clientList.items = data;
        state.clientList.success = true; 
        state.clientList.pagination.current_page = current_page;
        state.clientList.pagination.per_page = per_page;
        state.clientList.pagination.total = total;
    },
    getClientListFail: (state, action) => {        
        state.clientList.requesting = false;
        state.clientList.error = action.payload;
    },
    getClientDetails: (state) => {
        state.clientDetails.requesting = true;
        state.clientDetails.error = null;
        state.clientDetails.data = null;
        state.clientDetails.success = false; 
    },
    getClientDetailsSuccess: (state, action) => {
        state.clientDetails.requesting = false;
        state.clientDetails.data = action.payload;
        state.clientDetails.success = true; 
    },
    getClientDetailsFail: (state, action) => {        
        state.clientDetails.requesting = false;
        state.clientDetails.error = action.payload;
    },
    doClientCreate: (state) => {
        state.clientDetails.requesting = true;
        state.clientDetails.error = null;
        state.clientDetails.data = null;
        state.clientDetails.success = false; 
    },
    doClientUpdate: (state) => {
        state.clientDetails.requesting = true;
        state.clientDetails.error = null;
        state.clientDetails.data = null;
        state.clientDetails.success = false; 
    },
    doClientDelete: (state) => {
        state.clientDetails.requesting = true;
        state.clientDetails.error = null;
        state.clientDetails.data = null;
        state.clientDetails.success = false; 
    },
    // for client team
    getClientTeamList: (state, action) => {
        state.clientTeamList.requesting = true;
        state.clientTeamList.error = null;
        state.clientTeamList.items = [];
        state.clientTeamList.success = false;
        state.clientTeamList.filters = action.payload;
    },
    getClientTeamListSuccess: (state, action) => {
		const { data, current_page, per_page, total} = action.payload;
        state.clientTeamList.requesting = false;        
        state.clientTeamList.items = data;
        state.clientTeamList.success = true; 
        state.clientTeamList.pagination.current_page = current_page;
        state.clientTeamList.pagination.per_page = per_page;
        state.clientTeamList.pagination.total = total;
    },
    getClientTeamListFail: (state, action) => {        
        state.clientTeamList.requesting = false;
        state.clientTeamList.error = action.payload;
    },
    getClientTeamDetails: (state) => {
        state.clientTeamDetails.requesting = true;
        state.clientTeamDetails.error = null;
        state.clientTeamDetails.data = null;
        state.clientTeamDetails.success = false; 
    },
    getClientTeamDetailsSuccess: (state, action) => {
        state.clientTeamDetails.requesting = false;
        state.clientTeamDetails.data = action.payload;
        state.clientTeamDetails.success = true; 
    },
    getClientTeamDetailsFail: (state, action) => {        
        state.clientTeamDetails.requesting = false;
        state.clientTeamDetails.error = action.payload;
    },
    doClientTeamCreate: (state) => {
        state.clientTeamDetails.requesting = true;
        state.clientTeamDetails.error = null;
        state.clientTeamDetails.data = null;
        state.clientTeamDetails.success = false; 
    },
    doClientTeamUpdate: (state) => {
        state.clientTeamDetails.requesting = true;
        state.clientTeamDetails.error = null;
        state.clientTeamDetails.data = null;
        state.clientTeamDetails.success = false; 
    },
    doClientTeamDelete: (state) => {
        state.clientTeamDetails.requesting = true;
        state.clientTeamDetails.error = null;
        state.clientTeamDetails.data = null;
        state.clientTeamDetails.success = false; 
    },
    // for client users
    getClientUserList: (state, action) => {
        state.clientUserList.requesting = true;
        state.clientUserList.error = null;
        state.clientUserList.items = [];
        state.clientUserList.success = false;
        state.clientUserList.filters = action.payload;
    },
    getClientUserListSuccess: (state, action) => {
		const { data, current_page, per_page, total} = action.payload;
        state.clientUserList.requesting = false;        
        state.clientUserList.items = data;
        state.clientUserList.success = true; 
        state.clientUserList.pagination.current_page = current_page;
        state.clientUserList.pagination.per_page = per_page;
        state.clientUserList.pagination.total = total;
    },
    getClientUserListFail: (state, action) => {        
        state.clientUserList.requesting = false;
        state.clientUserList.error = action.payload;
    },
    getClientUserDetails: (state) => {
        state.clientUserDetails.requesting = true;
        state.clientUserDetails.error = null;
        state.clientUserDetails.data = null;
        state.clientUserDetails.success = false; 
    },
    getClientUserDetailsSuccess: (state, action) => {
        state.clientUserDetails.requesting = false;
        state.clientUserDetails.data = action.payload;
        state.clientUserDetails.success = true; 
    },
    getClientUserDetailsFail: (state, action) => {        
        state.clientUserDetails.requesting = false;
        state.clientUserDetails.error = action.payload;
    },
    doClientUserCreate: (state) => {
        state.clientUserDetails.requesting = true;
        state.clientUserDetails.error = null;
        state.clientUserDetails.data = null;
        state.clientUserDetails.success = false; 
    },
    doClientUserUpdate: (state) => {
        state.clientUserDetails.requesting = true;
        state.clientUserDetails.error = null;
        state.clientUserDetails.data = null;
        state.clientUserDetails.success = false; 
    },
    doClientUserDelete: (state) => {
        state.clientUserDetails.requesting = true;
        state.clientUserDetails.error = null;
        state.clientUserDetails.data = null;
        state.clientUserDetails.success = false; 
    },
    // for setting
    getClientSettingList: (state, action) => {		
      state.clientSettingList.requesting = true;
      state.clientSettingList.error = null;
      state.clientSettingList.items = [];
      state.clientSettingList.success = false;
      state.clientSettingList.filters = action.payload;
      state.clientSettingDetails.data = null;
    },
    getClientSettingListSuccess: (state, action) => {
      state.clientSettingList.requesting = false;        
      state.clientSettingList.items = action.payload;
      state.clientSettingList.success = true; 
    },
    getClientSettingListFail: (state, action) => {        
      state.clientSettingList.requesting = false;
      state.clientSettingList.error = action.payload;
    },
    getClientSettingDetails: (state) => {
      state.clientSettingDetails.requesting = true;
      state.clientSettingDetails.error = null;
      state.clientSettingDetails.data = null;
      state.clientSettingDetails.success = false; 
    },
    getClientSettingDetailsSuccess: (state, action) => {
      state.clientSettingDetails.requesting = false;
      state.clientSettingDetails.data = action.payload;
      state.clientSettingDetails.success = true; 
    },
    getClientSettingDetailsFail: (state, action) => {        
      state.clientSettingDetails.requesting = false;
      state.clientSettingDetails.error = action.payload;
    },
    doClientSettingUpdate: (state) => {
      state.clientSettingDetails.requesting = true;
      state.clientSettingDetails.error = null;
      state.clientSettingDetails.data = null;
      state.clientSettingDetails.success = false; 
    },
    doDeleteSupervisor: (state) => {
      state.clientTeamDetails.requesting = true;
      state.clientTeamDetails.success = false; 
    },
    doDeleteSupervisorSuccess: (state, action) => {
      state.clientTeamDetails.requesting = false;
      state.clientTeamDetails.success = true; 
    },
    doDeleteSupervisorFail: (state, action) => {
      state.clientTeamDetails.requesting = false;
      state.clientTeamDetails.success = false; 
    },
    },
})

export const { 
    getClientList, getClientListSuccess, getClientListFail,
    getClientDetails, getClientDetailsSuccess, getClientDetailsFail,
    doClientCreate, doClientUpdate, doClientDelete,
    getClientTeamList, getClientTeamListSuccess, getClientTeamListFail,
    getClientTeamDetails, getClientTeamDetailsSuccess, getClientTeamDetailsFail,
    doClientTeamCreate, doClientTeamUpdate, doClientTeamDelete,
    getClientUserList, getClientUserListSuccess, getClientUserListFail,
    getClientUserDetails, getClientUserDetailsSuccess, getClientUserDetailsFail,
    doClientUserCreate, doClientUserUpdate, doClientUserDelete,
    getClientSettingList, getClientSettingListSuccess, getClientSettingListFail,
    getClientSettingDetails, getClientSettingDetailsSuccess, getClientSettingDetailsFail,
    doClientSettingUpdate,
    doDeleteSupervisor, doDeleteSupervisorSuccess, doDeleteSupervisorFail,
} = clientSlice.actions 

export default clientSlice.reducer